import React from "react";
import { Box, alpha, useTheme } from "@mui/material";
import { StatusTone } from "./types";

interface StatusDotProps {
  tone?: StatusTone;
  className?: string;
  pulse?: boolean;
  "data-testid"?: string;
}

const pulseAnimation = {
  "@keyframes pulse": {
    "0%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.5,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
  },
};

export function StatusDot({ tone = "neutral", className, pulse, "data-testid": dataTestId }: StatusDotProps) {
  const theme = useTheme();
  
  const getColorForTone = (tone: StatusTone): string => {
    switch (tone) {
      case "ok":
        return theme.palette.success.main;
      case "warn":
        return theme.palette.warning.main;
      case "error":
        return theme.palette.error.main;
      case "accent":
        return theme.palette.primary.main;
      case "neutral":
      default:
        return theme.palette.text.disabled;
    }
  };

  const color = getColorForTone(tone);

  return (
    <Box
      className={className}
      data-tone={tone}
      data-testid={dataTestId}
      sx={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: color,
        boxShadow: `0 0 4px ${alpha(color, 0.7)}`,
        ...(pulse && {
          animation: "pulse 2s infinite",
          ...pulseAnimation,
        }),
      }}
    />
  );
}